import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getPhoneCall = (configuration: IConfigurationParams[]): boolean => {
  const phoneCall = configuration.find((
    params,
  ) => params.name === ConfigurationNames.phoneCall);

  return phoneCall ? JSON.parse(phoneCall.configuration).enabled : false;
};